'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FlapperIcon = function FlapperIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('circle', {
                fill: '#FDF6E3',
                opacity: '.8',
                cx: '65',
                cy: '65',
                r: '65'
            }),
            _react2.default.createElement('path', {
                fill: '#FFF',
                d: 'M51.515 50.21v-6.034h27.98v6.034h-5.142v7.502h-18.2V50.21zM30 55h8v32h-8zM92 55h8v30h-8z'
            }),
            _react2.default.createElement('path', {
                fill: '#FFF',
                d: 'M20 58h90v23H20z'
            }),
            _react2.default.createElement('path', {
                d: 'M50.32 43v8.301h4.903v5.985l-15.256.013v-4.392h-11.78v4.54H20v1.891h8.304l-.116 20.246H20v1.864h8.188V87h11.779l-.053-5.565H90.39L90.444 87h11.781v-5.723h7.77v-1.693h-7.77l-.08-20.246 7.855-.002V57.33h-7.77l-.007-4.423h-11.78v4.392l-14.501.124V51.3h4.9V43H50.32zm2.302 2.46V43.14v2.185h25.92V48.975h-25.92V45.46zm4.902 11.48v-5.639H73.64v5.74l-16.117-.1zm34.64 28.067h8.224V55.005h-8.224v30.002zm-62.203 0h8.012l.063-30.002h-8.012l-.063 30.002zm9.981-25.701H90.304l.055 20.278h-6.593l-39.424-.043h-4.375l-.025-20.235zm55.124 1.708h2.505v-2.322h-2.505v2.322zm-62.258 0h2.504v-2.322h-2.504v2.322zm62.258 10.425h2.505v-2.322h-2.505v2.322zm-62.258 0h2.504v-2.322h-2.504v2.322zm62.258 10.425h2.505v-2.323h-2.505v2.323zm-62.258 0h2.504v-2.323h-2.504v2.323z',
                fill: '#555'
            })
        )
    );
};

FlapperIcon.defaultProps = {
    width: '130',
    height: '130',
    viewBox: '0 0 130 130',
    xmlns: 'http://www.w3.org/2000/svg'
};

var Flapper = function (_React$Component) {
    _inherits(Flapper, _React$Component);

    function Flapper() {
        _classCallCheck(this, Flapper);

        return _possibleConstructorReturn(this, (Flapper.__proto__ || Object.getPrototypeOf(Flapper)).apply(this, arguments));
    }

    _createClass(Flapper, [{
        key: 'render',
        value: function render() {

            var size = (0, _helpers2.default)(this.props.size || "medium", this.props.type, this.props.screenSize);

            return _react2.default.createElement(FlapperIcon, { width: size.width + 'px', height: size.height + 'px' });
        }
    }]);

    return Flapper;
}(_react2.default.Component);

exports.default = Flapper;